import { motion } from "framer-motion";
import { ASSETS, CONTACT } from "../lib/brand";
import { IconInstagram } from "./icons";

const GRID = [ASSETS.rack, ASSETS.phone, ASSETS.hangers, ASSETS.hero];

export default function InstagramStrip() {
  return (
    <section
      data-testid="instagram-section"
      className="relative bg-cream-100 py-24 sm:py-32 border-t border-ink-800/15"
    >
      <div className="mx-auto max-w-[1600px] px-6 sm:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-8 mb-14">
          <div>
            <div className="flex items-center gap-4 font-mono text-[10px] uppercase tracking-[0.3em] text-ink-800/60 mb-6">
              <span className="w-8 h-px bg-brick-500" />
              <span>Diário — Instagram</span>
            </div>
            <h2
              className="font-serif leading-[0.95] tracking-tight text-ink-800 flex items-center gap-5 flex-wrap"
              style={{ fontSize: "clamp(2.5rem, 5vw, 5rem)" }}
            >
              <span className="italic-serif text-brick-500">O diário</span>
              <span>de bastidor</span>
            </h2>
          </div>
          <a
            href={CONTACT.instagram}
            target="_blank"
            rel="noreferrer"
            aria-label="Seguir no Instagram"
            data-testid="instagram-follow-cta"
            className="self-start lg:self-end inline-flex items-center gap-4 border border-ink-800 hover:bg-ink-800 hover:text-cream text-ink-800 px-6 py-4 transition-colors duration-500"
          >
            <IconInstagram size={20} strokeWidth={1.6} />
            <span className="font-mono text-[11px] uppercase tracking-[0.24em]">Seguir</span>
          </a>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 sm:gap-5">
          {GRID.map((img, i) => (
            <motion.a
              key={i}
              href={CONTACT.instagram}
              target="_blank"
              rel="noreferrer"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7, delay: i * 0.08 }}
              className="relative aspect-square overflow-hidden bg-cream-200 group"
              data-testid={`ig-tile-${i}`}
            >
              <img
                src={img}
                alt={`Post ${i + 1}`}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1.2s] ease-out group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-brick-500 mix-blend-multiply opacity-0 group-hover:opacity-60 transition-opacity duration-500" />
              <div className="absolute inset-0 flex items-end p-4 opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-cream">
                  Ver post →
                </span>
              </div>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
}
